import { LdTypo } from "@liquid/react";
import { paths } from "@src/router/paths";
import { StyledHeader, StyledNavLink } from "./Header.style";

function Header() {
  return (
    <>
      <StyledHeader siteName="DNA Base Editor" data-testid="header">
        <StyledNavLink to={paths.root} data-testid="header-navlink-dashboard">
          <LdTypo variant="h6">Home</LdTypo>
        </StyledNavLink>
      </StyledHeader>
    </>
  );
}

export { Header };
